import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "featureName", "usageTracker", "screen", "disabled", "tooltipPlacement"];
import { CreditsIcon } from 'foundations-assets';
import { COMPONENT_NAMES } from '../../../../shared/constants';
import { ComponentViewTracker } from '../../../../utils/UsageTracking/ComponentViewTracker';
import { CreditStatusTooltip } from '../CreditStatusTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreditIconWithTooltip = _ref => {
  let {
      action,
      featureName,
      usageTracker,
      screen,
      disabled,
      tooltipPlacement
    } = _ref,
    iconProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  // TODO: fix this when feature status endpoint is ready
  // featureType currently isn't used but will be soon, so we're making it a required prop for new consumers
  // using "CUSTOMER_AGENT" for now to satisfy TS, but it has no real effect on the tooltip
  const tooltipStatusProp = action ? {
    action
  } : {
    featureType: 'CUSTOMER_AGENT'
  };
  return /*#__PURE__*/_jsx(ComponentViewTracker, {
    screen: screen,
    usageTracker: usageTracker,
    componentName: COMPONENT_NAMES.CREDIT_ICON_WITH_TOOLTIP,
    children: /*#__PURE__*/_jsx(CreditStatusTooltip, Object.assign({
      featureName: featureName,
      disabled: disabled,
      placement: tooltipPlacement
    }, tooltipStatusProp, {
      children: /*#__PURE__*/_jsx(CreditsIcon, Object.assign({
        "data-test-id": "credit-icon-with-tooltip",
        "aria-label": "HubSpot Credits icon",
        color: disabled ? 'icon-core-disabled' : 'icon-core-default'
      }, iconProps))
    }))
  });
};